module.exports = __webpack_public_path__ + "img/pyb.d34ea0b3.png";